<script lang="ts">
    import { langField } from "../../i18n"

    import { breadcrumbs } from "../../store"
</script>

{#if $breadcrumbs?.length && $breadcrumbs[$breadcrumbs.length - 1].children?.length}
    <section id="teasernav" class="section_padding">
        <div class="container">
            <h1>{langField($breadcrumbs[$breadcrumbs.length - 1].name, "")}</h1>
            <div class="catlist">
                {#each $breadcrumbs[$breadcrumbs.length - 1].childObjects as c (c.id)}
                    <div class="item">
                        <div class="image">
                            <img
                                src="{c.image?.src ? c.image.src + '?filter=s' : '/media/kein-bild.jpg'}"
                                alt="{langField(c.name, '')}"
                            />
                        </div>
                        <div class="text">
                            <h4>{langField(c.name, "")}</h4>
                            <!--
                            <p>
                                Lorem ipsum dolor sit amet nec sagittis bibendum
                                tempor in
                            </p>
                            -->
                        </div>
                        <!-- svelte-ignore a11y-missing-content -->
                        <a href="{langField(c.path, '')}"></a>
                    </div>
                {/each}
            </div>
        </div>
    </section>
{/if}

<style lang="less">
    @import "../../css/variables.less";

    #teasernav {
        background: var(--surface);
        color: var(--on-surface);
    }
    .catlist {
        .flex();
        flex-wrap: wrap;
        margin: -1%;
        @media (max-width: 420px) {
            flex-direction: column;
        }
        .item {
            transition: all 0.3s;
            position: relative;
            width: 31%;
            margin: 1%;
            .flex();
            align-items: center;
            @media (max-width: 1100px) {
                width: 48%;
            }
            @media (max-width: 600px) {
                flex-direction: column;
            }
            @media (max-width: 420px) {
                width: 100%;
                flex-direction: row;
                margin-bottom: 20px;
            }
            .image {
                transition: all 0.3s;
                width: 120px;
                height: 120px;
                border: solid 1px #999;
                border-radius: 100%;
                padding: 10px;
                overflow: hidden;
                flex-shrink: 0;
                .flex();
                align-items: center;
                justify-content: center;
                flex-direction: column;
                margin-right: 20px;
                margin-bottom: 10px;
                @media (max-width: 900px) {
                    width: 10vw;
                    height: 10vw;
                }
                @media (max-width: 600px) {
                    width: 100px;
                    height: 100px;
                    margin-right: 0;
                }
                @media (max-width: 420px) {
                    margin-right: 10px;
                    width: 80px;
                    height: 80px;
                    margin-bottom: 0px;
                }
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
            .text {
                width: 60%;
                line-height: 1.2;
                .flex();
                flex-direction: column;
                justify-content: center;
                h4 {
                    font-size: 1.3rem;
                    margin-top: 0px;
                    margin-bottom: 5px;
                }
                /*p {
                    margin: 0px;
                }*/
                @media (max-width: 600px) {
                    width: 100%;
                    text-align: center;
                }
                @media (max-width: 420px) {
                    text-align: left;
                }
            }
            a {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                cursor: pointer;
            }
            &:hover {
                color: var(--primary);
                .image {
                    border-color: var(--primary);
                }
            }
        }
    }
</style>
